import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ExcelService } from "app/core/services/excel.service";
import { FileUploadModule } from "ng2-file-upload";
import { TreeTableModule, TreeTableToggler } from "primeng/treetable";
import { AppSpinnerModule } from "./app-loader/appspinner.module";
import { AppStandardInfoComponent } from "./app-standardinfo/appstandardinfo.component";
import { OnlynumberDirective } from "./custom-directive/onlynumber.directive";
import { DataFilterPipe } from "./custom-pipe/customfilter.pipe";
import { DateFilterPipe } from "./custom-pipe/dateFilter.pipe";
import { ExpressionFilterPipe } from "./custom-pipe/expression.pipe";
import { ImagePipe } from "./custom-pipe/image.pipe";
import { DataInputFilterPipe } from "./custom-pipe/inputfilter.pipe";
import { IOTypeValuePipe } from "./custom-pipe/ioTypeFilter.pipe";
import { LogTracerMessageFilterPipe } from "./custom-pipe/logTracerMessageFilterPipe";
import { OperatorNameMappingFilter } from "./custom-pipe/operationNameFilter-pipe";
import { OperatorMappingFilter } from "./custom-pipe/operatorFilter-pipe";
import { ProcessTypeValuePipe } from "./custom-pipe/processTypeFilter.pipe";
import { RoleFilterPipe } from "./custom-pipe/roleFilter-pipe";
import { ShowValuePipe } from "./custom-pipe/showValue.pipe";
import { StatusMappingFilter } from "./custom-pipe/statusFilter-pipe";
import { VariableExpressionFilterPipe } from "./custom-pipe/variableName.pipe";
@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    TranslateModule,
    AppSpinnerModule,
    TreeTableModule,
  ],
  exports: [
    NgbModule,
    FileUploadModule,
    ImagePipe,
    ShowValuePipe,
    DataFilterPipe,
    RoleFilterPipe,
    IOTypeValuePipe,
    ProcessTypeValuePipe,
    DateFilterPipe,
    DataInputFilterPipe,
    ExpressionFilterPipe,
    LogTracerMessageFilterPipe,
    VariableExpressionFilterPipe,
    StatusMappingFilter,
    OperatorMappingFilter,
    OperatorNameMappingFilter,
    AppStandardInfoComponent,
    OnlynumberDirective,
    AppSpinnerModule,
    TreeTableModule,
  ],
  declarations: [
    ImagePipe,
    ShowValuePipe,
    DataFilterPipe,
    DataInputFilterPipe,
    RoleFilterPipe,
    ExpressionFilterPipe,
    IOTypeValuePipe,
    ProcessTypeValuePipe,
    DateFilterPipe,
    LogTracerMessageFilterPipe,
    VariableExpressionFilterPipe,
    StatusMappingFilter,
    OperatorMappingFilter,
    OperatorNameMappingFilter,
    AppStandardInfoComponent,
    OnlynumberDirective,
  ],
  providers: [ExcelService, DatePipe],
})
export class SharedModule {}
